const SERVER_URL =
  "https://lmp-registration-backend-nodejs-895924407291.asia-south1.run.app";

//const SERVER_URL = "https://lmp-registration-backend-nodejs-rbac-895924407291.us-central1.run.app");

const IMAGE_URL = "https://storage.googleapis.com/kidsstreet-test/";

module.exports = {
  SERVER_URL,
  IMAGE_URL,
};
